import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Alert } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../../hooks.js';
import { showEmailResentAlertSelector } from '../../passwordlessSlice.js';
export const ResendEmailSuccessAlert = () => {
    const { t } = useTranslation();
    const showEmailResentAlert = useAppSelector(showEmailResentAlertSelector);
    const message = t('loginregistration.passwordless.resendEmail.success');
    return showEmailResentAlert ? (_jsx(Alert, { mb: 'spaceL', isDismissible: false, children: message })) : null;
};
//# sourceMappingURL=ResendEmailSuccessAlert.js.map